/* eslint-disable react/display-name */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popper,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
} from '@material-ui/core';
import Alert from '../../../common/components/Alert';
import { getCookie } from '../../../common/utils/cookies';
import React, { useState, useRef, useCallback } from 'react';
import { PossibleQuestion, ResponseLabels, ViewAll, Response, Progress } from '../../interfaces/surveyScreen';
import BlockIcon from '@material-ui/icons/Block';
import { QuestionTheme } from '../../styles/mfsTheme';
import { ViewAllStyles } from '../../styles/ViewAllScreenStyles';
import { useTranslation } from 'react-i18next';
import { DesktopHelpTooltipStyles, RatingQuestionStyles } from '../../styles';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';
import ProgressBar from '../../common/ProgressBar/Progressbar';
import { AnswerLabel } from '../../interfaces/HelpToolTip';
import { getCleanLabels } from '../../utils/helper';
import MobileHelpToolTip from '../../common/HelpTooltip/MobileHelpTooltip';
import CompetencyMobileHelpToolTip from '../../common/HelpTooltip/CompetencyMobileTooltip';
import { allQuestions as getAllQuestions } from '../../utils/questionMapper';
import axios from '../../../common/utils/interceptor';
import { apiUrls } from '../../../constants';
import { surveyTypes } from '../../constants/shl360';
import { questionMap } from '../../utils/questionMapper';
import { scrollToBottom, getServerDomain } from '../../utils/helper';
import { FullPageLoader } from '../../../common/components/FullPageLoader';
import { LayoutStyles as HideFooter } from '../../styles/common';
import { useBasicDetails } from '../../../store/storeApi';
import QuestionnaireSection from './viewAllComponents/QuestionnaireSection';
import ImportanceRatingSection from './viewAllComponents/ImportanceRatingSection';
import AdditionalQuestionsSection from './viewAllComponents/AdditionalQuestionsSection';
import { sendEventsDetails, sendPageViewDetails } from '../../../common/utils/gaEvents';
import {
  GARouteMappings,
  GAPageViewMappings,
  GACategoryMappings,
  GAActionMappings,
} from '../../../constants/gaMappings';
import { useAppSelector } from '../../../redux-store/hook';

let attempted = 0;

const ViewAllScreen = ({
  questionData,
  QULabels,
  IRlabels,
  backFromViewAll,
  questionProgress,
  updateParentStore,
  showThankYou,
  isPreview,
}: ViewAll): JSX.Element => {
  /** Page View GA method */
  React.useEffect(() => {
    sendPageViewDetails(GARouteMappings.SHL360_VIEWALL, GAPageViewMappings.SHL360_VIEWALL);
  }, []);

  let savedResponses = 0;
  const qus = [...questionData];
  const classes = ViewAllStyles(QuestionTheme);
  const customClass = HideFooter();
  const [loading, setLoading] = useState<boolean>(true);
  const [allQuestions, setAllQuestions] = useState<PossibleQuestion[]>(qus);
  const clsRQ = RatingQuestionStyles(QuestionTheme);
  const clsDHS = DesktopHelpTooltipStyles(QuestionTheme);
  const { t } = useTranslation();
  const theme = useTheme();
  const pageHeadingRef = useRef<HTMLHeadingElement>(null);
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { QU, IR, AD } = getAllQuestions(qus);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [popperContent, setPopperContent] = React.useState<null | PossibleQuestion>(null);
  const [isCompToolTip, setIsCompToolTip] = React.useState<boolean>(false);
  const [isValidating, setIsValidating] = React.useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [enableNextStep, setEnableNextStep] = React.useState(false);
  const [isError, setIsError] = React.useState<boolean>(false);
  const [progress, setProgress] = React.useState<Progress>(questionProgress);
  const [pageStartTime] = useState<Date>(new Date());
  const QUSecLength = QU && QU.length ? QU.length + 2 : 1;
  const IRSecLength = (IR && IR.length ? IR.length + 1 : 0) + QUSecLength;
  const BackBtnRef = useRef<HTMLButtonElement>(null);
  const NextBtnRef = useRef<HTMLButtonElement>(null);
  const template = useAppSelector((state) => state.template);
  const candidate = useAppSelector((state) => state.candidate);

  const {
    headerOptions: { selectedTheme },
  } = useBasicDetails();

  const sendGAEvents = (): void => {
    sendEventsDetails(GACategoryMappings.SHL360_VIEWALL, GAActionMappings.SHL360_VIEWALL, pageStartTime, '', 'SHL360', {
      templateData: template,
      candidate,
    });
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>, question: PossibleQuestion, isComp?: boolean): void => {
    setPopperContent(question);
    if (open) {
      setAnchorEl(null);
      setOpen(false);
    } else {
      setAnchorEl(event.currentTarget);
      setOpen(true);
    }
    if (isComp) {
      setIsCompToolTip(true);
    } else {
      setIsCompToolTip(false);
    }
  };

  const getLabels = useCallback((type: string): ResponseLabels[] => {
    if (type === surveyTypes.QU) {
      return QULabels;
    } else if (type === surveyTypes.IR) {
      return IRlabels;
    } else {
      return [];
    }
  }, []);

  const getQuestionToUpdate = (data: PossibleQuestion): PossibleQuestion => {
    const type = data.type;
    let question = data.itemId || data.itemID ? questionMap(data) : data;
    if (type === surveyTypes.QU || type === surveyTypes.IR) {
      question = { ...question, labels: getLabels(type) };
    }
    return question;
  };

  const updateProgress = React.useCallback(({ totalQus, attempted }: Progress) => {
    setProgress({
      totalQus: totalQus,
      attempted: attempted > totalQus ? totalQus : attempted,
    });
  }, []);

  const getAttempedQus = React.useCallback(
    (data: Array<PossibleQuestion>): number => {
      let attemptedQus = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i].type !== surveyTypes.TIPS && data[i].type !== surveyTypes.INTRO) {
          if (
            (data[i].type === surveyTypes.OQ && data[i].questMust === 0) ||
            (data[i].selectedResponse !== null && data[i].selectedResponse !== '')
          ) {
            attemptedQus++;
          }
        }
      }
      return attemptedQus;
    },
    [allQuestions],
  );

  const submitResponse = async (res: Response, seq?: number | string): Promise<void> => {
    const tempStore = [...allQuestions];
    const prevResponse = tempStore[seq as number].selectedResponse;
    try {
      setEnableNextStep(false);
      tempStore[seq as number].selectedResponse = res.response;
      setAllQuestions(tempStore);
      if (tempStore[seq as number].type !== 'OQ' && prevResponse === null) {
        updateProgress({ ...progress, attempted: ++attempted });
      } else {
        if (prevResponse === null || prevResponse === '') {
          updateProgress({ ...progress, attempted: ++attempted });
        }
      }
      savedResponses++;
      const config = { headers: { sid: getCookie('sid') }, withCredentials: false };
      const { data } = !isPreview
        ? await axios.post(getServerDomain(apiUrls.POST_SURVEY_ANSWERS), res, config)
        : { data: { status: 'SUCCESS' } };
      if (data.status === 'SUCCESS') {
        setIsError(false);
        if (getAttempedQus(allQuestions) === progress.totalQus && savedResponses <= 1) {
          setEnableNextStep(true);
        }
      } else {
        setEnableNextStep(false);
        updateProgress({ ...progress, attempted: --attempted });
        tempStore[seq as number].selectedResponse = null;
        setAllQuestions([...tempStore]);
        setIsError(true);
        throw new Error('error');
      }
    } catch (e) {
      setIsError(true);
      scrollToBottom();
      throw new Error('error');
    } finally {
      savedResponses--;
    }
  };

  const updateResponse = async (data: string, qseq?: number | string): Promise<string> => {
    let Status = '';
    const qData = (allQuestions[qseq as number] && getQuestionToUpdate(allQuestions[qseq as number])) || [];
    if (qData.itemId || qData.itemID) {
      const req = {
        type: qData.type,
        itemId: qData.itemId || qData.itemID,
        scaleId: qData.type === surveyTypes.QU ? qData.scaleId : null,
        response: data,
      };
      try {
        await submitResponse(req, qseq);
        Status = 'SUCCESS';
      } catch (ex) {
        Status = 'ERROR';
      }
    }
    return Status;
  };

  const validateSections = (): void => {
    setIsValidating(true);
    if (getAttempedQus(allQuestions) === progress.totalQus) {
      setIsValidating(false);
      showThankYou(true);
      sendGAEvents();
      backFromViewAll();
    }
  };

  const onInputChange = (value: string, id?: string): void => {
    updateResponse(value.trim() || '', id);
    if (value.trim() === '') {
      --attempted;
      updateProgress({ ...progress, attempted: attempted });
      setEnableNextStep(false);
    }
  };

  const onBackClick = useCallback((): void => {
    updateParentStore(allQuestions);
    sendGAEvents();
    backFromViewAll();
  }, []);

  React.useEffect(() => {
    setTimeout(() => {
      if (pageHeadingRef.current) {
        pageHeadingRef.current.focus();
      }
      setLoading(false);
    }, 500);
    attempted = getAttempedQus(allQuestions);
    updateProgress({ ...progress, attempted: attempted });
    if (attempted === progress.totalQus && savedResponses === 0) {
      setEnableNextStep(true);
    }
  }, []);

  const populateLabels = React.useCallback(
    (label: AnswerLabel, type: PossibleQuestion[]): JSX.Element => {
      return (
        <ListItem
          key={label.value}
          className={`${type.length && !type[0].hasNoEvidence && label.value === '0' ? clsDHS.displayNone : ''}`}>
          <ListItemIcon className={clsDHS.listItemIcon}>
            <div className={clsDHS.listItem} aria-label={`Response option ${label.value}`} aria-required="true">
              {label.value === '0' ? <BlockIcon className={clsDHS.labelIcon} /> : label.value}
            </div>
          </ListItemIcon>
          <ListItemText
            primary={getCleanLabels(label.description)}
            aria-label={`Response option ${label.value} ${label.description}`}
            aria-required="true"
          />
        </ListItem>
      );
    },
    [open, selectedTheme],
  );

  const QUSectionBox = React.useMemo(() => {
    return (
      <Box className={classes.section}>
        <Typography aria-label={QU[0] ? QU[0].title : ''} className={`${classes.sectionTitle} ${classes.bold}`}>
          {QU[0] ? QU[0].title : ''}
        </Typography>
        <IconButton
          className={classes.ratingHelpIcon}
          aria-hidden={true}
          onClick={(event): void => handleClick(event, QU[0])}
          data-testid="openHelpQU">
          <HelpOutlineIcon className={classes.toolTipIcon} />
        </IconButton>
        <Popper
          open={open && popperContent?.type === 'QU'}
          anchorEl={anchorEl}
          placement="right-start"
          className={classes.nonCompPopper}>
          <div>
            <div className={classes.compPopperContent}>
              <div className={clsDHS.headerBox}>
                <Typography className={clsDHS.lineHeight3} variant="h6">
                  {t('ratingScale')}
                </Typography>
                <IconButton
                  data-testid="closeQUButton"
                  aria-label={t('close')}
                  onClick={(event): void => handleClick(event, QU[0])}
                  className={classes.closeIconIE}>
                  <CloseIcon fontSize="small" className={clsDHS.contrastText} />
                </IconButton>
              </div>
              <List dense={true}>{QULabels && QULabels.map((item) => populateLabels(item, QU))}</List>
            </div>
            <span className={`${classes.arrowLeft} ${classes.arrow}`}></span>
          </div>
        </Popper>
      </Box>
    );
  }, [open, selectedTheme]);

  const IRSectionBox = React.useMemo(() => {
    return (
      <Box className={classes.section}>
        <Typography className={`${classes.sectionTitle} ${classes.bold}`} aria-label={IR[0] ? IR[0].questionText : ''}>
          {IR[0] ? IR[0].questionText : ''}
        </Typography>
        <IconButton
          className={classes.ratingHelpIcon}
          aria-hidden="true"
          onClick={(event): void => handleClick(event, IR[0])}
          data-testid="openHelpIR">
          <HelpOutlineIcon className={classes.toolTipIcon} />
        </IconButton>
        <Popper
          open={open && popperContent?.type === 'IR' && !isCompToolTip && smUp}
          anchorEl={anchorEl}
          placement="right-start"
          className={classes.nonCompPopper}>
          <div>
            <div className={classes.compPopperContent}>
              <div className={clsDHS.headerBox}>
                <Typography className={clsDHS.lineHeight3} variant="h6">
                  {t('ratingScale')}
                </Typography>
                <IconButton
                  data-testid="closeIRButton"
                  aria-label={t('close')}
                  onClick={(event): void => handleClick(event, IR[0])}
                  className={classes.closeIconIE}>
                  <CloseIcon fontSize="small" className={clsDHS.contrastText} />
                </IconButton>
              </div>
              <List dense={true}>{IRlabels && IRlabels.map((item) => populateLabels(item, IR))}</List>
            </div>
            <span className={`${classes.arrowLeft} ${classes.arrow}`}></span>
          </div>
        </Popper>
      </Box>
    );
  }, [open, selectedTheme]);

  if (loading) {
    return <FullPageLoader isLoading={true} customClass={customClass.screenContainer} />;
  }

  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.content}>
          <Typography ref={pageHeadingRef} tabIndex={-1} variant="h5" className={classes.heading}>
            {t('mfsViewAllHeading')}
          </Typography>
          <Box display={QU.length > 0 ? 'block' : 'none'}>
            {QUSectionBox}
            <QuestionnaireSection
              questionnaire={QU}
              labels={QULabels}
              isValidating={isValidating}
              updateResponse={updateResponse}
            />
          </Box>
          <Box display={IR.length > 0 ? 'block' : 'none'}>
            {IRSectionBox}
            <ImportanceRatingSection
              importanceRatingQuestions={IR}
              IRlabels={IRlabels}
              QUSecLength={QUSecLength}
              isValidating={isValidating}
              updateResponse={updateResponse}
              handleClick={handleClick}
            />
            <Popper
              open={open && popperContent?.type === 'IR' && isCompToolTip && smUp}
              anchorEl={anchorEl}
              placement="left-start"
              className={classes.compPopper}>
              {popperContent ? (
                <div className={classes.displayFlex}>
                  <div className={classes.compPopperContent}>
                    <Box className={classes.displayFlex}>
                      <Typography className={`${classes.bold} ${classes.compPopperHeading}`}>
                        {popperContent.competencyName}
                      </Typography>
                      <IconButton
                        data-testid="closeCompButton"
                        aria-label={t('close')}
                        onClick={(event): void => handleClick(event, IR[0], true)}
                        className={classes.closeIcon}>
                        <CloseIcon fontSize="small" className={clsDHS.contrastText} />
                      </IconButton>
                    </Box>
                    <Typography className={classes.font14}>{popperContent.competencyDescription}</Typography>
                  </div>
                  <span className={classes.arrow}></span>
                </div>
              ) : (
                <></>
              )}
            </Popper>
          </Box>
          <Box display={AD.length > 0 ? 'block' : 'none'}>
            <Typography className={`${classes.sectionTitle} ${classes.bold}`}>{t('additionalHeading')}</Typography>
            <AdditionalQuestionsSection
              additionalQuestions={AD}
              IRSecLength={IRSecLength}
              isValidating={isValidating}
              updateResponse={updateResponse}
              onInputChange={onInputChange}
              backButtonRef={BackBtnRef}
              nextButtonRef={NextBtnRef}
            />
          </Box>
          <Alert show={isValidating && attempted < progress.totalQus} state="error" gridClassName={classes.errorAlert}>
            {t('answerAllQuestions')}
          </Alert>
          <Alert show={isError} state="error" gridClassName={classes.errorAlert}>
            {t('responsesNotSaved')}
          </Alert>
          <Box className={clsRQ.footer}>
            <Grid container spacing={1} justify="center">
              <Grid item lg={6} sm={6} className={clsRQ.alignLeft}>
                <Box id="footer" className={clsRQ.footerBack}>
                  <Button
                    variant="outlined"
                    color="primary"
                    className={clsRQ.backBtn}
                    onClick={onBackClick}
                    aria-label={t('back')}
                    ref={BackBtnRef}
                    aria-required="true">
                    <NavigateBeforeIcon className={clsRQ.backArrowIcon} /> {t('back')}
                  </Button>
                </Box>
              </Grid>
              <Grid item lg={6} sm={6} className={clsRQ.alignRight}>
                <Box className={clsRQ.footerNext}>
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={!enableNextStep}
                    className={clsRQ.backBtn}
                    aria-label={t('next')}
                    onClick={validateSections}
                    ref={NextBtnRef}
                    aria-required="true">
                    {t('next')} <NavigateNextIcon className={clsRQ.nextArrowIcon} />
                  </Button>
                </Box>
              </Grid>
              <Grid container item lg={12} sm={12} alignItems="center">
                <ProgressBar attempted={attempted} total={progress.totalQus} isViewAllPage={true} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      {open && popperContent?.type === 'QU' && !smUp && (
        <MobileHelpToolTip labels={QULabels} setOpen={setOpen} open={open} hasNoEvidence={true} />
      )}
      {open && popperContent?.type === 'IR' && !isCompToolTip && !smUp && (
        <MobileHelpToolTip labels={IRlabels} setOpen={setOpen} open={open} hasNoEvidence={true} />
      )}
      {open && popperContent?.type === 'IR' && isCompToolTip && !smUp && (
        <CompetencyMobileHelpToolTip
          competencyName={popperContent?.competencyName}
          open={open}
          setOpen={setOpen}
          competencyDesc={popperContent?.competencyDescription}
        />
      )}
    </>
  );
};

export default React.memo(ViewAllScreen);
